import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { FormioLoader } from 'dp-formio';
import { map, Observable, startWith } from 'rxjs';

import { DialogData, DialogEventHook, DialogResult } from '../models';

@Component({
	selector: 'app-schedule-dialog',
	templateUrl: './schedule-dialog.component.html',
	styleUrls: ['./schedule-dialog.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class ScheduleDialogComponent implements OnInit {
	submission: DialogData['submission'];
	formKey: DialogData['formKey'] = 'testVisitSession';
	hookType: DialogData['dialogHook'] = 'afterSubmit';
	dir$: Observable<any>;
	constructor(
		public dialogRef: MatDialogRef<ScheduleDialogComponent, DialogResult>,
		@Inject(MAT_DIALOG_DATA) public dialogData: DialogData,
		public loader: FormioLoader,
		private translateService: TranslateService
	) {
		this.dir$ = (this.translateService.onLangChange as Observable<LangChangeEvent>).pipe(
			startWith({
				lang: this.translateService.currentLang,
			}),
			map((lang) => (lang.lang == 'ar' ? 'rtl' : 'ltr'))
		);
	}

	ngOnInit(): void {
		this.loader.loading = false;
		this.formKey = this.dialogData?.formKey;
		this.submission = this.dialogData?.submission;
		this.hookType = this.dialogData?.dialogHook;
	}

	cancel(){
		this.dialogRef.close();
	}
	customEvent(event: any) {
		if (event.component?.key == 'cancel') {
			this.dialogRef.close();
		}

		if (event.component?.key === 'submit' && this.hookType === 'customEvent') {
			this._closeAndEmitData(event.data, this.hookType);
		}
	}

	beforeSubmit(event: any) {
		if (this.hookType === 'beforeSubmit') {
			this._closeAndEmitData(event.data, this.hookType);
		}
	}
	onSubmit(event: any) {
		if (this.hookType === 'afterSubmit') {
			this._closeAndEmitData(event.submission, this.hookType);
		}
	}

	private _closeAndEmitData(data: any, hook: DialogEventHook) {
		this.dialogRef.close({
			data: data,
			type: this.dialogData.type,
			hook: hook,
		});
	}
}
